<h2 mat-dialog-title class="text-align-center">Session Expiring Soon</h2>
<mat-dialog-content class="m-t-1 m-b-1">
  <p>Your session is about to expire, please click continue to stay logged in. You will be logged out in {{secondsToExpire}} seconds.</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button cdkFocusInitial mat-dialog-close="">Continue</button>
</mat-dialog-actions>
